<template>
  <ZigzagServiceLayout
    mainTitle="Servidios de Atención Primaria General"
    mainDescription="Desde niños hasta adultos, nuestro equipo bilingüe está aquí para brindar atención accesible y personalizada para cada etapa de la vida."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'PrimaryContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ATENCIÓN PRIMARIA',
          title: 'Prevención y Bienestar',
          subtitle: 'Visitas periódicas para ayudar a monitorear y cuidar su salud.',
          paragraphs: [
            "Los chequeos de rutina y la atención preventiva son esenciales para mantener una salud óptima.",
            "Ofrecemos evaluaciones completas, vacunas para proteger a los niños y adultos, y exámenes físicos escolares requeridos para mantener seguros a los niños."
          ],
          list: [
            "Exámenes físicos anuales",
            "Visitas de bienestar con planes personalizados",
            "Vacunación e inmunizaciones",
            "Exámenes físicos escolares"
          ],
          image: '/images/services/primary-prevention.png'
        },
        {
          label: 'CUIDADO CRÓNICO',
          title: 'Manejo de Condiciones',
          subtitle: 'Apoyo a largo plazo para sus condiciones de salud.',
          paragraphs: [
            "Brindamos monitoreo continuo y tratamiento para controlar problemas crónicos como diabetes e hipertensión.",
            "Nuestros planes tienen como objetivo reducir el riesgo cardiovascular, manejar trastornos de la tiroides y el control de peso supervisado."
          ],
          list: [
            "Manejo de la diabetes",
            "Control de hipertensión y colesterol alto",
            "Trastornos de la tiroides",
            "Obesidad y control de peso"
          ],
          image: '/images/services/primary-chronic.png'
        },
        {
          label: 'ATENCIÓN ESPECIALIZADA',
          title: 'Pruebas de Salud y Atención de Agudos',
          subtitle: 'Detección temprana y alivio rápido.',
          paragraphs: [
            "La detección temprana salva vidas; ofrecemos exámenes integrales para la presión arterial, colesterol y diabetes.",
            "Además, brindamos alivio rápido para resfriados, lesiones menores y tratamientos personalizados para alergias."
          ],
          list: [
            "Exámenes médicos para la detección temprana",
            "Atención de urgencia y visitas por enfermedad",
            "Lesiones menores y cuidado de heridas",
            "Tratamiento de dolores de cabeza y alergias"
          ],
          image: '/images/services/primary-specialized.png'
        },
        {
          label: 'CUIDADO HOLÍSTICO',
          title: "Salud Mental, Femenina y Masculina",
          subtitle: 'Ayuda integral adaptada a usted.',
          paragraphs: [
            "Suministramos atención de rutina para todas las etapas de la vida de mujeres y hombres, desde planificación familiar hasta TRT.",
            "Además, ofrecemos atención conductual integral para la ansiedad, la depresión y el TDAH."
          ],
          list: [
            "Exámenes de la mujer, manejo de SOP y menopausia",
            "Evaluación masculina, DE y TRT",
            "Salud mental y manejo de la ansiedad",
            "Procedimientos menores: quistes y lóbulo de la oreja"
          ],
          image: '/images/weight-loss/img-principal-new.webp'
        }
      ]
    };
  }
};
</script>
